import { Input } from '@amzn/meridian';
import { useUniqueElementId } from 'app.util';
import { useSchema } from 'features/traffic/campaigns/useSchema';
import pluralize from 'pluralize';
import { useMemo } from 'react';
import { getRefTagMaxLength } from './ref-tag-config';

type GeneratedRefTagDisplayProps = {
  refTag: string;
};

export const GeneratedRefTagDisplay = ({ refTag }: GeneratedRefTagDisplayProps) => {
  const controlId = useUniqueElementId('generated-ref-tag-display');
  const schema = useSchema();
  const maxRefTagLength = getRefTagMaxLength(schema);
  const refTagTooLong = refTag.length > maxRefTagLength;

  const refTagTooLongMessage = useMemo(() => {
    if (!refTagTooLong) return;
    const diff = refTag.length - maxRefTagLength;
    return `The auto-generated ref tag is too long. Shorten the Event Name or Additional Text fields by ${diff} ${pluralize(
      'character',
      diff,
    )}, or turn off auto-generation to manually edit the
        ref tag (not recommended).`;
  }, [
    refTag.length,
    refTagTooLong,
    maxRefTagLength,
  ]);

  return (
    <Input disabled error={refTagTooLong} errorMessage={refTagTooLongMessage} id={controlId} label="Ref tag (generated)" value={refTag} />
  );
};
